import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useContentLibrary } from '../../providers/content_library_provider';
import ClauseSearchResult from './clause';
const TABLE_CHUNK_SIZE = 25;
const ClauseSearchResults = ({ clauses, queryInfo }) => {
    const { getMoreClauses } = useContentLibrary();
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (clauses.length > 0) {
            setTableData(clauses.slice(0, tableData.length + TABLE_CHUNK_SIZE));
        }
    }, [clauses]);
    const takeMore = () => {
        const endIndex = tableData.length + TABLE_CHUNK_SIZE;
        if (endIndex > clauses.length && queryInfo.pageNumber < queryInfo.totalPages) {
            getMoreClauses();
        }
        else {
            setTableData(clauses.slice(0, tableData.length + TABLE_CHUNK_SIZE));
        }
    };
    const totalRows = (queryInfo === null || queryInfo === void 0 ? void 0 : queryInfo.totalRecords) || 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("h4", { className: 'results-count' },
            "Clause Results ",
            React.createElement("b", null,
                "(",
                totalRows,
                ")")),
        React.createElement("div", { className: 'results-container-clause', id: 'scrollable-results' },
            React.createElement(InfiniteScroll, { dataLength: (tableData === null || tableData === void 0 ? void 0 : tableData.length) || (clauses === null || clauses === void 0 ? void 0 : clauses.length), next: takeMore, hasMore: (tableData.length !== totalRows) ||
                    (queryInfo.pageNumber < queryInfo.totalPages), loader: React.createElement("div", { className: 'loading-results' }, "Loading More Clauses..."), scrollableTarget: 'scrollable-results' }, tableData.map((clause, index) => React.createElement(ClauseSearchResult, { "data-testid": `clause-search-result-${index}`, key: clause.id, clause: clause }))))));
};
export default ClauseSearchResults;
